import "./EditIssueSubscriptions.html";
import "./EditIssueSubscriptions.scss";

import "../FindAddUser/FindAddUserComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditIssueSubscriptionsComponentController from "./EditIssueSubscriptionsComponentController";

export default class EditIssueSubscriptionsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            configurationGroup: "=",
            site: "<",
            subscribersAssigned: "=",
            subscriptions: "=",
            disabled: "<",
        };
        this.controller = EditIssueSubscriptionsComponentController;
        this.templateUrl = "/App/Components/Forms/EditIssueSubscriptions/EditIssueSubscriptions.html";
    }
}

module("mmManagePortal").component("irEditIssueSubscriptions", new EditIssueSubscriptionsComponent());
